export function exhaustiveGuard(something: never): never {
  throw new Error(`this should never happen: ${something}`)
}
